import { defineStore } from 'pinia';
import { requestAnimationFrame } from '@/utils/browser';

export const useBackdropStore = defineStore('backdrop', {
  state: () => ({
    zIndex: 2000,
    lockClassName: 'overflow-hidden',
    measureClassName: 'scrollbar-measure',
    isBodyOverflowing: false,
    scrollbarWidth: 0,
    layers: [],
  }),

  actions: {
    increaseIndex() {
      this.zIndex++;
    },

    registerLayer(key) {
      this.layers.push({
        key: key,
        opened: false,
      });
    },

    toggleLayer(key, value) {
      const layer = this.layers.find(e => e.key === key);

      if (layer) {
        layer.opened = value;
      }

      if (layer && value) {
        this.lockScroll();
      }

      if (layer && !value) {
        this.unlockScroll();
      }
    },

    unregister(key) {
      const index = this.layers.findIndex(cfg => cfg.key === key);

      if (index >= 0) {
        this.layers.splice(index, 1);
        this.unlockScroll();
      }
    },

    lockScroll() {
      requestAnimationFrame(() => {
        this.checkScrollbar();

        if (this.isBodyOverflowing) {
          document.body.style.paddingRight = `${this.scrollbarWidth}px`;
        }

        document.body.classList.add(this.lockClassName);
      });
    },

    checkScrollbar() {
      const rect = document.body.getBoundingClientRect();
      this.isBodyOverflowing = rect.left + rect.right < window.innerWidth;
      this.scrollbarWidth = this.getScrollbarWidth();
    },

    getScrollbarWidth() {
      const scrollDiv = document.createElement('div');
      scrollDiv.className = this.measureClassName;
      document.body.appendChild(scrollDiv);

      const scrollWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollWidth;
    },

    unlockScroll() {
      // checks if there are no opened layers like modals
      if (this.getVisibleLayerCount() === 0) {
        requestAnimationFrame(() => {
          if (document.body) {
            document.body.style.paddingRight = '';
            document.body.classList.remove(this.lockClassName);
          }
        });
      }
    },

    getVisibleLayerCount() {
      return this.layers.filter(layer => layer.opened).length;
    },
  },
});
